{
  "name": "automatr-ui",
  "version": "2.20.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "devlocalssl": "ng serve --ssl true --ssl-key ../certs/devcerts/localhost-key.pem --ssl-cert ../certs/devcerts/localhost.pem",
    "remotelocalssl": "ng serve --configuration devremote --ssl true --ssl-key ../certs/devcerts/localhost-key.pem --ssl-cert ../certs/devcerts/localhost.pem",
    "locallocalssl": "ng serve --configuration devlocal --ssl true --ssl-key ../certs/devcerts/localhost-key.pem --ssl-cert ../certs/devcerts/localhost.pem",
    "devlocalsslexperiemnt": "ng serve --configuration devremoteexperiment --ssl true --ssl-key ../certs/devcerts/localhost-key.pem --ssl-cert ../certs/devcerts/localhost.pem",
    "remotelocalsslexperiemnt": "ng serve --configuration devremoteexperiment --ssl true --ssl-key ../certs/devcerts/localhost-key.pem --ssl-cert ../certs/devcerts/localhost.pem",
    "devremotebuild": "ng build --c=devremote",
    "releasebuild": "ng build --c=release",
    "build:devonprem": "ng build --c=devonprem",
    "build:releaseonprem": "ng build --configuration=releaseonprem",
    "build:prodonprem": "ng build --configuration=prodonprem"
  },
  "private": true,
  "dependencies": {
    "@angular-slider/ngx-slider": "^2.0.4",
    "@angular/animations": "^19.2.14",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.14",
    "@angular/compiler": "^19.2.14",
    "@angular/core": "^19.2.14",
    "@angular/elements": "^19.2.14",
    "@angular/forms": "^19.2.14",
    "@angular/google-maps": "^19.2.19",
    "@angular/platform-browser": "^19.2.14",
    "@angular/platform-browser-dynamic": "^19.2.14",
    "@angular/router": "^19.2.14",
    "@angular/service-worker": "^19.2.14",
    "@asymmetrik/ngx-leaflet": "^15.0.1",
    "@babel/runtime": "^7.25.7",
    "@ckeditor/ckeditor5-angular": "^4.0.0",
    "@ckeditor/ckeditor5-build-classic": "^35.4.0",
    "@formio/angular": "^7.0.0",
    "@formio/js": "^5.2.0",
    "@fortawesome/angular-fontawesome": "^0.12.0",
    "@fortawesome/fontawesome-free": "^6.4.2",
    "@fullcalendar/angular": "6.0.0",
    "@fullcalendar/core": "6.0.0",
    "@fullcalendar/daygrid": "6.0.0",
    "@fullcalendar/interaction": "6.0.0",
    "@fullcalendar/list": "^6.0.0",
    "@fullcalendar/timegrid": "^6.0.0",
    "@microsoft/signalr": "^8.0.7",
    "@microsoft/signalr-protocol-msgpack": "^8.0.7",
    "@ng-bootstrap/ng-bootstrap": "^17.0.1",
    "@ng-select/ng-select": "^10.0.1",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^7.0.0",
    "@popperjs/core": "^2.11.6",
    "@primeng/themes": "^20.0.1",
    "@tiptap/core": "^2.27.2",
    "@tiptap/extension-table": "^2.27.2",
    "@tiptap/extension-table-cell": "^2.27.2",
    "@tiptap/extension-table-header": "^2.27.2",
    "@tiptap/extension-table-row": "^2.27.2",
    "@tiptap/pm": "^2.27.2",
    "@tiptap/starter-kit": "^2.27.2",
    "@types/jasmine": "4.3.1",
    "@types/leaflet": "1.9.0",
    "@types/node": "18.11.15",
    "@types/uuid": "^10.0.0",
    "ace-builds": "^1.43.6",
    "angular-archwizard": "^7.0.0",
    "angular-feather": "6.5.0",
    "angular-formio-pdf": "^0.1.5",
    "angular-oauth2-oidc": "15.0.1",
    "angular-oauth2-oidc-jwks": "15.0.1",
    "angularx-flatpickr": "7.0.0",
    "apexcharts": "3.36.3",
    "bootstrap": "5.2.0",
    "bootstrap-icons": "^1.13.1",
    "chart.js": "^2.9.4",
    "docx-preview": "^0.3.7",
    "echarts": "5.4.1",
    "file-saver": "2.0.5",
    "firebase": "9.15.0",
    "flatpickr": "4.6.13",
    "google-libphonenumber": "^3.2.38",
    "intl-tel-input": "^17.0.21",
    "jasmine-core": "4.5.0",
    "jquery": "^3.7.1",
    "json-server": "0.17.1",
    "karma": "6.4.1",
    "karma-chrome-launcher": "3.1.1",
    "karma-coverage": "2.2.0",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.0.0",
    "leaflet": "1.9.3",
    "lodash": "^4.17.21",
    "marked": "^16.2.0",
    "metismenujs": "1.3.1",
    "moment": "2.29.4",
    "msgpack5": "^6.0.2",
    "ng-apexcharts": "1.7.4",
    "ng-otp-input": "1.8.5",
    "ng2-charts": "2.4.2",
    "ngx-bootstrap": "^20.0.0",
    "ngx-chartist": "1.0.3",
    "ngx-color-picker": "13.0.0",
    "ngx-cookie-service": "15.0.0",
    "ngx-daterangepicker-material": "6.0.4",
    "ngx-dropzone-wrapper": "13.0.0",
    "ngx-echarts": "15.0.1",
    "ngx-intl-tel-input": "^3.2.0",
    "ngx-json-viewer": "^3.2.1",
    "ngx-lightbox": "3.0.0",
    "ngx-markdown-editor": "^5.3.4",
    "ngx-mask": "14.2.4",
    "ngx-owl-carousel-o": "15.0.0",
    "ngx-spinner": "15.0.1",
    "ngx-toastr": "^16.1.0",
    "ngx-typeahead": "^18.0.0",
    "ngx-ui-switch": "14.0.3",
    "ngx-youtube-player": "12.0.2",
    "papaparse": "^5.5.3",
    "pdfjs-dist": "5.4.624",
    "primeicons": "^7.0.0",
    "primeng": "^19.1.4",
    "rxjs": "^7.8.2",
    "simplebar-angular": "2.5.0",
    "sweetalert2": "^11.4.8",
    "tslib": "^2.4.1",
    "uuid": "^11.1.0",
    "xlsx": "^0.18.5",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.15",
    "@angular/cli": "^19.2.15",
    "@angular/compiler-cli": "^19.2.14",
    "@angular/localize": "^19.2.14",
    "@types/chart.js": "^2.9.37",
    "@types/file-saver": "^2.0.5",
    "@types/googlemaps": "^3.39.13",
    "@types/papaparse": "^5.5.2",
    "typescript": "^5.8.3"
  }
}
